/* ============================================================
   biker-pdp.js — Ágata María · v3
   PDP Chaqueta Tipo Biker Irreverente
   - Vanilla JS modular · sin dependencias
   - Live search con catálogo real + redirect a producto
   - Form VIP integrado con Shopify Customer
     (envía welcome email automático + segmenta con tags)

   Subir a: assets/biker-pdp.js
   ============================================================ */

(function () {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  let initialized = false;
  function init() {
    if (initialized) return;
    initialized = true;

    initMobileDrawer();
    initSearchOverlay();
    initLiveSearch();
    initGalleryThumbs();
    initSizeSelector();
    initShareCopy();
    initDeliveryRange();
    initVipForm();
  }

  /* ----------------------------------------------------------
     1 · Mobile drawer
     ---------------------------------------------------------- */
  function initMobileDrawer() {
    const openBtn = $('[data-open-menu]');
    const closeBtns = $$('[data-close-drawer], [data-close-drawer-also]');
    const drawer = $('[data-drawer]');
    const backdrop = $('[data-drawer-backdrop]');

    if (!openBtn || !drawer || !backdrop) return;

    const open = () => {
      drawer.hidden = false;
      backdrop.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('open');
        backdrop.classList.add('open');
      });
      document.body.classList.add('drawer-open');
    };
    const close = () => {
      drawer.classList.remove('open');
      backdrop.classList.remove('open');
      document.body.classList.remove('drawer-open');
      setTimeout(() => { drawer.hidden = true; backdrop.hidden = true; }, 550);
    };

    openBtn.addEventListener('click', open);
    backdrop.addEventListener('click', close);
    closeBtns.forEach(b => b.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }

  /* ----------------------------------------------------------
     2 · Search overlay
     ---------------------------------------------------------- */
  function initSearchOverlay() {
    const openBtns = $$('[data-open-search]');
    const closeBtn = $('[data-close-search]');
    const overlay = $('[data-search]');
    const input = $('[data-search-input]');

    if (!openBtns.length || !overlay) return;

    const open = () => {
      overlay.hidden = false;
      requestAnimationFrame(() => overlay.classList.add('open'));
      document.body.classList.add('drawer-open');
      setTimeout(() => input?.focus(), 60);
    };
    const close = () => {
      overlay.classList.remove('open');
      document.body.classList.remove('drawer-open');
      setTimeout(() => { overlay.hidden = true; }, 350);
    };

    openBtns.forEach(b => b.addEventListener('click', open));
    closeBtn?.addEventListener('click', close);
    overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }

  /* ----------------------------------------------------------
     3 · LIVE SEARCH con catálogo real + redirect a producto
     ---------------------------------------------------------- */
  function initLiveSearch() {
    const input = $('[data-search-input]');
    const overlay = $('[data-search]');
    if (!input || !overlay) return;

    // Catálogo Ágata María real (URLs verificadas)
    const SITE = window.location.origin;
    const CATALOG = [
      { name: 'Chaqueta Tipo Biker Irreverente', cat: 'Outerwear', price: '$ 927.500 COP', href: SITE + '/products/chaqueta-tipo-biker', img: SITE + '/products/chaqueta-tipo-biker.js' },
      { name: 'Blazer Visionario',                cat: 'Outerwear', price: '$ 1.260.000 COP', href: SITE + '/products/blazer',                  img: SITE + '/products/blazer.js' },
      { name: 'Chaqueta Bomber Vuelo Sagrado',    cat: 'Outerwear', price: '$ 1.550.000 COP', href: SITE + '/products/chaqueta-bomber',         img: SITE + '/products/chaqueta-bomber.js' },
      { name: 'Abrigo Kawsay',                    cat: 'Abrigos',   price: '$ 995.000 COP',   href: SITE + '/products/abrigo-kawsay',           img: SITE + '/products/abrigo-kawsay.js' },
      { name: 'Vestido Templo',                   cat: 'Vestidos',  price: '$ 1.350.000 COP', href: SITE + '/products/vestido-templo',          img: SITE + '/products/vestido-templo.js' },
      { name: 'Vestido Raíces Despiertas',        cat: 'Vestidos',  price: '$ 1.180.000 COP', href: SITE + '/products/vestido-raices-despiertas', img: SITE + '/products/vestido-raices-despiertas.js' },
      { name: 'Top con Peplum',                   cat: 'Tops',      price: '$ 680.000 COP',   href: SITE + '/products/top-con-peplum',          img: SITE + '/products/top-con-peplum.js' },
      { name: 'Mini Falda',                       cat: 'Faldas',    price: '$ 820.000 COP',   href: SITE + '/products/mini-falda',              img: SITE + '/products/mini-falda.js' },
    ];

    // Crear contenedor de resultados si no existe
    let resultsContainer = $('[data-search-results]', overlay);
    if (!resultsContainer) {
      resultsContainer = document.createElement('div');
      resultsContainer.className = 'search-results';
      resultsContainer.setAttribute('data-search-results', '');
      // Insertar después de las sugerencias o del form
      const suggestions = $('.search-suggestions', overlay);
      const panel = $('.search-panel', overlay);
      if (suggestions) suggestions.after(resultsContainer);
      else if (panel) panel.appendChild(resultsContainer);
    }

    // Cache de imágenes para no fetchar cada vez
    const imageCache = new Map();
    async function getProductImage(handle) {
      if (imageCache.has(handle)) return imageCache.get(handle);
      try {
        const res = await fetch(SITE + '/products/' + handle + '.js');
        if (!res.ok) return null;
        const data = await res.json();
        const url = data.featured_image || (data.images && data.images[0]) || null;
        imageCache.set(handle, url);
        return url;
      } catch (e) { return null; }
    }

    function render(query) {
      const q = query.trim().toLowerCase();
      const suggestions = $('.search-suggestions', overlay);
      if (!q) {
        resultsContainer.innerHTML = '';
        if (suggestions) suggestions.style.display = '';
        return;
      }
      if (suggestions) suggestions.style.display = 'none';

      const matches = CATALOG.filter(p =>
        p.name.toLowerCase().includes(q) || p.cat.toLowerCase().includes(q)
      );

      if (matches.length === 0) {
        resultsContainer.innerHTML = `
          <div class="search-results-empty">
            <p>Sin resultados para <em>"${escapeHtml(query.trim())}"</em></p>
            <p style="font-size:0.95rem;margin-top:0.4rem;color:var(--ink-soft);">Prueba con otra pieza, una categoría o explora <a href="${SITE}/collections/all" style="color:var(--marigold);border-bottom:1px solid var(--marigold);">todas las piezas</a>.</p>
          </div>`;
        return;
      }

      resultsContainer.innerHTML = matches.map((p, i) => `
        <a class="search-result-item" href="${p.href}" data-handle="${p.href.split('/').pop()}">
          <span class="search-result-thumb" data-thumb="${p.href.split('/').pop()}">
            <img src="" alt="${escapeHtml(p.name)}" loading="lazy">
          </span>
          <span class="search-result-info">
            <span class="search-result-cat">${escapeHtml(p.cat)}</span>
            <span class="search-result-name">${escapeHtml(p.name)}</span>
            <span class="search-result-price">${escapeHtml(p.price)}</span>
          </span>
          <span class="search-result-arrow">→</span>
        </a>
      `).join('');

      // Cargar thumbnails asíncronamente
      $$('.search-result-thumb', resultsContainer).forEach(async (thumb) => {
        const handle = thumb.dataset.thumb;
        const img = thumb.querySelector('img');
        const url = await getProductImage(handle);
        if (url && img) {
          // Shopify CDN URL relative format
          const full = url.startsWith('//') ? 'https:' + url : url;
          img.src = full.replace(/\.(jpe?g|png|webp)(\?.*)?$/, '_200x.$1$2');
        }
      });
    }

    let debounceTimer;
    input.addEventListener('input', e => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => render(e.target.value), 120);
    });

    // Si el form tiene un Enter, si hay solo 1 resultado va directo
    const form = input.closest('form');
    if (form) {
      form.addEventListener('submit', e => {
        const q = input.value.trim().toLowerCase();
        if (!q) return;
        const exact = CATALOG.find(p => p.name.toLowerCase() === q);
        if (exact) {
          e.preventDefault();
          window.location.href = exact.href;
        }
      });
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  /* ----------------------------------------------------------
     4 · Galería · thumbs sincronizados
     ---------------------------------------------------------- */
  function initGalleryThumbs() {
    const thumbs = $$('.am-app .thumb');
    const images = $$('.am-app .gallery-image, .am-app .main-image');
    if (!thumbs.length || !images.length) return;

    thumbs.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        thumbs.forEach(b => b.classList.remove('active'));
        images.forEach(img => img.classList.remove('is-active'));
        btn.classList.add('active');
        images[i]?.classList.add('is-active');
      });
    });
  }

  /* ----------------------------------------------------------
     5 · Selector de talla
     ---------------------------------------------------------- */
  function initSizeSelector() {
    const buttons = $$('.am-app .size-option');
    const priceEl = $('[data-price]');
    const ctaCart = $('[data-cta-cart]');
    const ctaWa = $('[data-cta-whatsapp]');
    const msgText = $('[data-size-msg-text]');
    const sizeLabelValue = $('[data-selected-size]');

    if (!buttons.length) return;

    const cartBaseUrl = window.location.origin + '/cart/';

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('disabled')) return;
        buttons.forEach(b => {
          b.classList.remove('selected');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('selected');
        btn.setAttribute('aria-checked', 'true');

        const variantId = btn.dataset.variantId;
        const price = btn.dataset.variantPrice;
        const title = btn.dataset.variantTitle;
        const available = btn.dataset.variantAvailable === 'true';

        if (priceEl && price) priceEl.textContent = price;
        if (sizeLabelValue) sizeLabelValue.textContent = title;

        if (ctaCart && variantId) {
          ctaCart.href = available ? `${cartBaseUrl}${variantId}:1` : '#';
          if (available) ctaCart.classList.remove('is-disabled');
          else ctaCart.classList.add('is-disabled');
          ctaCart.textContent = available ? 'Añadir al carrito' : 'Talla agotada';
        }
        if (ctaWa) {
          const msg = `Hola, me interesa la Chaqueta Tipo Biker Irreverente en talla ${title}. ¿Está disponible?`;
          // Preservar el ícono del WhatsApp
          const icon = ctaWa.querySelector('svg');
          ctaWa.href = `https://wa.me/573004562905?text=${encodeURIComponent(msg)}`;
          if (icon && !ctaWa.querySelector('svg')) ctaWa.prepend(icon);
        }
        if (msgText) {
          msgText.textContent = available
            ? `Talla ${title} disponible. Edición limitada — no se repone.`
            : `Talla ${title} agotada. Únete a la Lista VIP para próximos reabastecimientos.`;
        }
      });
    });
  }

  /* ----------------------------------------------------------
     6 · Copiar link
     ---------------------------------------------------------- */
  function initShareCopy() {
    const btn = $('[data-share-copy]');
    const label = $('[data-share-copy-label]');
    if (!btn || !label) return;

    btn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(window.location.href);
        label.textContent = '✓ Copiado';
        setTimeout(() => { label.textContent = 'Copiar'; }, 2000);
      } catch {
        label.textContent = 'Copia manual';
        setTimeout(() => { label.textContent = 'Copiar'; }, 2000);
      }
    });
  }

  /* ----------------------------------------------------------
     7 · Entrega estimada +2 a +4 días
     ---------------------------------------------------------- */
  function initDeliveryRange() {
    const el = $('[data-delivery-range]');
    if (!el) return;
    const fmt = new Intl.DateTimeFormat('es-CO', { day: '2-digit', month: 'short' });
    const start = new Date(); start.setDate(start.getDate() + 2);
    const end = new Date();   end.setDate(end.getDate() + 4);
    el.textContent = `${fmt.format(start)} — ${fmt.format(end)}`;
  }

  /* ----------------------------------------------------------
     8 · VIP form
     - Chips → hidden input contact[note][intereses]
     - Al submit: también dispara Meta Pixel Lead
     - El form usa {% form 'customer' %} de Shopify → registra
       en Email Marketing y envía welcome email automático.
     - WhatsApp opcional como confirmación adicional al cliente.
     ---------------------------------------------------------- */
  function initVipForm() {
    const form = $('#vipForm') || $('[data-vip-form]') || $('form.vip-form');
    if (!form) return;

    const chipsHidden = $('[data-chips-hidden]', form);
    const chips = $$('.chip-group .chip', form);
    const selected = new Set();

    chips.forEach(chip => {
      chip.addEventListener('click', () => {
        const v = chip.dataset.chip;
        if (selected.has(v)) {
          selected.delete(v);
          chip.classList.remove('active');
        } else {
          selected.add(v);
          chip.classList.add('active');
        }
        if (chipsHidden) chipsHidden.value = Array.from(selected).join(', ');
      });
    });

    form.addEventListener('submit', e => {
      // No prevenir — dejar que Shopify procese el form
      // Solo loggear evento Meta Pixel Lead
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: 'Lista VIP · Atelier Privado',
          content_category: 'newsletter_signup',
          source: 'biker-pdp'
        });
      }
      // Opcional: abrir también WhatsApp como confirmación visual al cliente
      // (sin pausar el submit del form a Shopify)
      const email = $('#vip-email', form)?.value || '';
      const nombre = $('#vip-nombre', form)?.value || '';
      const intereses = chipsHidden?.value || '—';
      if (email) {
        const wa = `https://wa.me/573004562905?text=${encodeURIComponent(
          `Hola Ágata María ✦\n\nQuiero unirme a la Lista VIP.\n\nNombre: ${nombre || '—'}\nEmail: ${email}\nIntereses: ${intereses}`
        )}`;
        // Abre WhatsApp como segundo canal (opcional, comentar si no se quiere)
        // setTimeout(() => window.open(wa, '_blank', 'noopener,noreferrer'), 500);
      }
    });
  }
})();